import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "isShow", "events"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 14:42:21
 * @LastEditTime: 2021-07-02 15:16:30
 * @LastEditors: wangshengqiang
 * @Description: d
 */
import React from 'react';
import classnames from 'classnames';
import { Iconfont } from '@/baseComponents';
import { useLocalClick } from '@/components/Button';
const DetailRemark = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    children,
    isShow = true,
    events = {}
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    'components-detail-remark-render': true,
    [className]: !!className
  });
  const onClick = useLocalClick(events);

  if (!isShow) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: cls,
    onClick: onClick
  }, others), /*#__PURE__*/React.createElement(Iconfont, {
    className: "icon",
    type: "xiangxibeizhu"
  }));
});
export default DetailRemark;